export const separateThousandsWithPrime = (number: number | undefined) => {
  if (typeof number === 'number') {
    const numStr = String(number);
    const parts = [];

    for (let i = numStr.length; i > 0; i -= 3) {
      const start = Math.max(0, i - 3);
      const part = numStr.slice(start, i);
      parts.unshift(part);
    }

    return parts.join('’');
  } else {
    return '';
  }
};
